function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "img-visa");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "UID",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Payment-Method",
  transform: "translate(-28.000000, -123.000000)"
}, React.createElement("g", {
  id: "img-visa",
  transform: "translate(28.000000, 123.000000)"
}, React.createElement("rect", {
  id: "base",
  fill: "#0066B2",
  x: 0,
  y: 0,
  width: 55,
  height: 55,
  rx: 10
}), React.createElement("g", {
  id: "logo",
  transform: "translate(12.000000, 23.000000)"
}, React.createElement("path", {
  d: "M11.5915327,0.152881223 L14.0297922,0.152881223 L12.504116,9.10231282 L10.0666405,9.10231282 L11.5915327,0.152881223 Z M10.6052528,0.162289298 L6.76519012,9.09290474 L4.18345747,9.09604077 L2,1.63543708 C3.57114857,2.63974912 4.90631125,4.23206586 5.37749902,5.34457076 L5.63230106,6.26577813 L8.02116817,0.162289298 L10.6052528,0.162289298 Z M20.9933359,6.17718542 C20.9753038,8.03606429 19.3124265,9.23637789 16.748726,9.23637789 C15.6558212,9.2246178 14.6021168,9.00980008 14.0297922,8.75891807 L14.372403,6.75578205 L14.6875735,6.9000392 C15.4903959,7.23402587 16.0078401,7.36887495 16.9847119,7.36887495 C17.6856135,7.36887495 18.4359075,7.09290474 18.4413955,6.49235594 C18.4453156,6.1003528 18.127009,5.82203058 17.1775774,5.38377107 C16.25245,4.95491964 15.0278322,4.23833791 15.0435123,2.95256762 C15.0552724,1.2128577 16.754998,0 19.1650333,0 C20.1081929,0 20.8647589,0.192865543 21.3484908,0.376323011 L21.0176401,2.31517052 L20.7973344,2.21089769 C20.3504508,2.03057624 19.7718542,1.85574285 18.9721678,1.86828695 C18.0196002,1.86828695 17.5758526,2.26656213 17.5758526,2.63974912 C17.5727166,3.05605645 18.0932967,3.33516268 18.9447276,3.74833399 C20.3535868,4.38573109 21.00588,5.16032928 20.9933359,6.17718542 L20.9933359,6.17718542 Z M24.5981968,5.93257546 C24.8004704,5.41748334 25.5687966,3.43002744 25.5687966,3.43002744 C25.5562525,3.45433163 25.7679341,2.9125833 25.8933751,2.5754606 L26.0588005,3.34770678 C26.0588005,3.34770678 26.5245002,5.48177185 26.622501,5.93257546 L24.5981968,5.93257546 Z M27.6056448,0.162289298 L25.7216778,0.162289298 C25.1368091,0.162289298 24.6993336,0.321442572 24.4453156,0.90631125 L20.8216386,9.10466484 L23.3822031,9.10466484 C23.3822031,9.10466484 23.8016464,8.00235202 23.8965112,7.76087809 C24.1756174,7.76087809 26.6656213,7.76636613 27.0207762,7.76636613 C27.0913367,8.07918463 27.3147785,9.10466484 27.3147785,9.10466484 L29.5774206,9.10466484 L27.6056448,0.162289298 Z",
  id: "img-visa",
  fill: "#FFFFFF"
}), React.createElement("path", {
  d: "M0.0305762446,0.0768326147 L3.8126225,0.0768326147 C4.32144257,0.0948647589 4.73147785,0.257154057 4.87573501,0.802038416 L5.69658957,4.75656605 C4.8874951,2.68914151 2.94315955,0.96746374 0,0.257154057 L0.0305762446,0.0768326147 Z",
  id: "Path",
  fill: "#F9A533"
})))));

var SvgCardtypeVisa = function SvgCardtypeVisa(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "55px",
    height: "55px",
    viewBox: "0 0 55 55",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCardtypeVisa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cardtype-visa.47ab42e7.svg";
export { ForwardRef as ReactComponent };